import { GetAccountSentimentReportAverageTotalsMetricsQuery } from '../../../../src/interface/queries/sentiment/get-account-sentiment-report-average-totals.query';
import { LogManager } from '../../../common/port/log/log.manager.port';
import { GetAccountSentimentReportAverageTotalsRequestDto } from '../../../../src/interface/dtos/sentiment/get-account-sentiment-report-totals-average.request.dto';
import { GetAccountSentimentReportAverageTotalsResponseDto } from '../../../../src/interface/dtos/sentiment/get-account-sentiment-report-totals-average.response.dto';
import { AccountSentimentReportAverageTotalsAggregateRootMapper } from '../../../infrastructure/mappers/sentiment/account-sentiment-report-average-totals-aggregate-root.mapper';

export class GetAccountSentimentReportAverageTotalsController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetAccountSentimentReportAverageTotalsMetricsQuery,
    protected readonly mapper: AccountSentimentReportAverageTotalsAggregateRootMapper
  ) {}

  async get(
    props: GetAccountSentimentReportAverageTotalsRequestDto
  ): Promise<GetAccountSentimentReportAverageTotalsResponseDto> {
    try {
      const result = await this.query.execute(props);
      return this.mapper.toResponse(result);
    } catch (error) {
      throw new Error(
        `GetAccountSentimentReportAverageTotalsController.get encountered an error ${error}`
      );
    }
  }
}
